'use strict';

import {
    changeLangToCurrent,
    getCurrentLang,
    getCurrentLangDirection,
    isDesktopMode
} from '../language/langSwitcher';
import {
    addCloseBtn,
    addHeader,
    createElements, createHtmlElement,
    findSelectionAndCrmData,
    flatClick,
    getObjectFromLocalStorage,
    handleFavoriteLogic,
    moveAroundTheFloors,
    numberWithCommas,
    rotation_to_flat, userPrevent,
} from '../../functions';
import {
    Buildings,
    cardsData,
    isMobile,
    projectMode,
    settingsData,
    threeJsVariables,
} from '../../settings';
import {rightNavMenuZIndexChange, viewModesSwitching} from "../navigation/right-nav-bar";
import {CardTypes, FilterTypes, SelectedObjectType, ViewMode} from "../../common";
import gsap from "gsap";
import { canvasResize, renderUpdateValuesOnDemand, updateLabels, updateRenderer } from '../../app';
import {facingDictionary} from "../cards/cardsConfig";
import {SwipeScript} from "../controls/swipe";
import {hideTooltip} from "../flatTooltip/flatTooltip";
import {Vector2} from "three";
import {bombButtonInitActionHandler} from "../controls/destroyBuilding";
import { hoverOutPreviousSelection, selectionBoxesSetStatusColor } from '../threejs/raycast';
import {createMultipleSearch, updateMultiSearch} from './multipleSearch';
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import {
    changeCardPositionWhenSearchOpen,
    changeKeyButtonState,
    setActiveClassHandler
} from "../cards/unitCards/unitCardFunctions";
import { getCookie } from '../cookies/setAndGetCookies';
import {
    postProcessingResize
} from "../post-processing/post-processing";
import {Tooltip} from "../tooltip/Tooltip";
import {Switch} from "../switch/Switch";

/**
 * Create search HTML elements
 * Create event listeners
 * */
export const selectedBuildings = new Set();

function createSearchModule() {
    if (containerMain) return;

    const mainContainerSize = 450;

    //Containers
    const containerMain = createElements('div', ['search__container-main'], document.body);
    const containerTop = createElements('div', ['search__container-top'], containerMain);
    const containerBottom = createElements('div', ['search__container-bottom'], isMobile && !settingsData.isLandscape ? document.body : containerMain);
    // const containerTopHeader = createElements('div', ['search__top-header'], containerTop);
    const containerTopWrapper = createElements('div', ['search__top-wrapper'], containerTop);

    if (!isMobile) {
        containerMain.setAttribute('data-size', `${mainContainerSize}`);
        containerMain.style.width = `${mainContainerSize}px`;
    } else {
        containerMain.classList.add('mobile');

        addHeader(containerMain, 'search');
        addCloseBtn(containerMain);

        //Event listeners
        addSwipeListenersToMainContainer(containerMain);
    }

    //Container bottom elements
    const classNames = (config.property.settings.displayPrice === 'hide' && !settingsData.isConferenceHost)
        ? ['search__sort', 'no-price']
        : ['search__sort'];

    const searchResultsWrapper = createElements('div', ['search__result-wrapper'], containerBottom);
    const searchResultsSort = createElements('div', classNames, containerBottom);
    const searchList = createElements('ul', ['search__result-list'], containerBottom);

    searchList.addEventListener('click', handleCardSelect, false);

    //Search result count
    createSearchResultsCount(searchResultsWrapper);

   //Buttons
    const searchButtons = [
        // {
        //     button: 'close',
        //     classNames: ['search__button', 'search__button-close', 'icon-right1'],
        //     container: containerTopHeader,
        //     position: 'afterbegin',
        // },
        // {
        //     button: 'clear',
        //     classNames: ['search__button', 'search__button-clear'],
        //     container: containerTopHeader,
        //     position: 'afterbegin',
        // },
        // {
        //     button: 'reset',
        //     classNames: ['search__button', 'search__button-reset', 'icon-reset-reload'],
        //     container: searchResultsWrapper,
        //     position: 'beforeend',
        // },
        {
            button: 'results',
            classNames: ['search__button', 'search__button-results'],
            container: settingsData.isLandscape ? containerTop : containerMain,
            position: 'afterbegin',
            innerHTML: `<span class="icon-list1"></span>`
        },
    ];
    createButtons(searchButtons);

    // Flexible search
    // createFlexibleSearch(containerTopHeader);

    //Create sort menu
    createSearchResultsSortMenu(searchResultsSort);

    //Create elements: range inputs, checkbox
    createSearchOptionsElements(containerTopWrapper);

    createMultipleSearch();

    // Set max-height container bottom
    setContainerMaxHeight(containerBottom, searchList);
}

function addSwipeListenersToMainContainer(containerMain) {
    SwipeScript(containerMain);

    if (settingsData.isLandscape) {
        (getCurrentLangDirection() === 'ltr')
            ? containerMain.addEventListener('swiped-right', mobileHandleSearch, false)
            : containerMain.addEventListener('swiped-left', mobileHandleSearch, false);
    } else {
        containerMain.addEventListener('swiped-down', mobileHandleSearch, false);
        containerMain.addEventListener('swiped-up', mobileHandleSearch, false);
    }
}

function createButtons(searchButtons) {
    searchButtons.forEach(buttonData => {
        const button = createElements('button', buttonData.classNames, buttonData.container, buttonData.position, {
            data: 'data-button',
            value: buttonData.button
        });

        if (buttonData.hasOwnProperty('innerHTML')) {
            button.innerHTML = buttonData.innerHTML;
        }

        switch (buttonData.button) {
            case 'close':
                button.addEventListener('click', removeSearchContainer, false);
                break;
            case 'reset':
                button.addEventListener('click', resetFilter, false);
                break;
            case 'clear':
                button.addEventListener('click', clearInputFlexible, false);
                break;
            case 'results':
                button.addEventListener('click', toggleResultsList, false);
                break;
        }
    });
}

function createSearchResultsCount(searchResultsWrapper) {
    const searchResultsCount = createElements('div', ['search__result-count'], searchResultsWrapper);

    // if (Buildings.getBuildingsInfoLength() > 1) {
    //     searchResultsCount.insertAdjacentHTML('beforeend', `
    //         <p class="language-string search__result-count--number"  data-dictionary="apartments found"> ${changeLangToCurrent('apartments found')}</p>
    //     `);
    // } else {
        searchResultsCount.insertAdjacentHTML('beforeend', `
            <span class="search__result-count--amount">0</span>
            <p class="language-string search__result-count--number"  data-dictionary="apartments found"> ${changeLangToCurrent('apartments found')}</p>
        `);
    // }

}

function createFlexibleSearch(containerTopHeader) {
    const inputLabel = createElements('label', ['search__label-flexible', 'icon-search'], containerTopHeader, 'afterbegin');
    const inputSearch = createElements('input', ['search__input', 'search__input-flexible', 'language-string'], inputLabel, 'beforeend', {
        data: 'type',
        value: 'text'
    });
    inputSearch.setAttribute('data-dictionary', 'searchPlaceholder');
    inputSearch.setAttribute('placeholder', `${changeLangToCurrent('searchPlaceholder')}`);

    inputSearch.addEventListener('input', flexibleSearchHandle, false);
    inputSearch.addEventListener('focus', inputFocusStyle, false);
    inputSearch.addEventListener('blur', inputFocusStyle, false);
}

function createMinMaxInputs(wrapper, minValue, maxValue, field) {
    const labelMin = createElements('label', ['search__label', 'search__label-min'], wrapper);
    const labelMax = createElements('label', ['search__label', 'search__label-max'], wrapper);

    if (field.key === 'salePrice') {
        labelMin.classList.add('search__label--token-money');
        labelMax.classList.add('search__label--token-money');
    }

    const elementInputMinValue = createElements('input', ['search__option-input', 'search__option-input--min'], labelMin, 'beforeend', {
        data: 'type',
        value: 'text'
    });
    elementInputMinValue.setAttribute('value', `${numberWithCommas(minValue)}`);
    elementInputMinValue.setAttribute('data-type', `${field.key}`);
    elementInputMinValue.setAttribute('data-value', `${minValue}`);

    const elementInputMaxValue = createElements('input', ['search__option-input', 'search__option-input--max'], labelMax, 'beforeend', {
        data: 'type',
        value: 'text'
    });
    elementInputMaxValue.setAttribute('value', `${numberWithCommas(maxValue)}`);
    elementInputMaxValue.setAttribute('data-type', `${field.key}`);
    elementInputMaxValue.setAttribute('data-value', `${maxValue}`);

    elementInputMinValue.addEventListener('focus', handleRangeInputs, false);
    elementInputMaxValue.addEventListener('focus', handleRangeInputs, false);

    elementInputMinValue.addEventListener('focusout', handleRangeInputs, false);
    elementInputMaxValue.addEventListener('focusout', handleRangeInputs, false);

    elementInputMinValue.addEventListener('change', handleRangeInputs, false);
    elementInputMaxValue.addEventListener('change', handleRangeInputs, false);

    elementInputMinValue.addEventListener('keyup', handleRangeInputs, false);
    elementInputMaxValue.addEventListener('keyup', handleRangeInputs, false);

    return {elementInputMinValue, elementInputMaxValue};
}

function createRange(inputCondition, elementContainer, field) {
    const minValue = Math.min(...inputCondition);
    const maxValue = Math.max(...inputCondition);
    const step = (+maxValue <= 100) ? 1 : 10;
    const minGap = 0;

    const wrapper = createElements('div', ['search__wrapper', 'search__wrapper-range'], elementContainer);

    const {searchState} = settingsData;
    const rangeDataInState = searchState.find(state => state.type === field.key);
    const startMinValue = (rangeDataInState) ? rangeDataInState.min : minValue;
    const startMaxValue = (rangeDataInState) ? rangeDataInState.max : maxValue;

    const {
        elementInputMinValue,
        elementInputMaxValue
    } = createMinMaxInputs(wrapper, startMinValue, startMaxValue, field);

    const rangeWrapper = createElements('div', ['search__range-wrapper'], wrapper);
    const rangeContainer = createElements('div', ['search__range-container'], rangeWrapper, '', {
        data: 'data-type',
        value: field.key
    });
    const rangeSliderTrack = createElements('div', ['search__range-slider-track'], rangeContainer);
    const rangeOne = createElements('input', ['search__range-input', 'search__range-input--one', `search__range-input--${field.key}`], rangeContainer);
    const rangeTwo = createElements('input', ['search__range-input', 'search__range-input--two', `search__range-input--${field.key}`], rangeContainer);

    const rangeValues = {
        'min': minValue,
        'max': maxValue,
        'value': {
            'startMinValue': startMinValue,
            'startMaxValue': startMaxValue,
        },
        'startMinValue': startMinValue,
        'startMaxValue': startMaxValue,
        'step': step,
        'data-type': field.key,
        'type': 'range'
    }

    setDataRangeInputs(rangeOne, rangeValues);
    setDataRangeInputs(rangeTwo, rangeValues);
    fillTrackColor(rangeSliderTrack, rangeOne, rangeTwo);


    // if (parseInt(rangeTwo.value) - parseInt(rangeOne.value) <= minGap) {
    if (+rangeOne.value === maxValue) {
        rangeOne.style.zIndex = 2;
        rangeTwo.style.zIndex = 1;
    } else if (+rangeTwo.value === maxValue) {
        rangeOne.style.zIndex = 1;
        rangeTwo.style.zIndex = 2;
    }
    // }

    // rangeOne.addEventListener('input', inputRangeHandler, false);
    // rangeTwo.addEventListener('input', inputRangeHandler, false);

    rangeOne.addEventListener('input', (e) => {
        e.preventDefault();
        if (parseInt(rangeTwo.value) - parseInt(rangeOne.value) <= minGap) {
            rangeOne.value = parseInt(rangeTwo.value) - minGap;
            //rangeOne.style.zIndex = 1;
            //rangeTwo.style.zIndex = 2;
        }

        elementInputMinValue.value = numberWithCommas(rangeOne.value);
        fillTrackColor(rangeSliderTrack, rangeOne, rangeTwo);

        const updateStateElement = searchState.find(item => item.type === field.key);
        if (!updateStateElement.hasOwnProperty('checked')) {
            updateStateElement.min = rangeOne.value;
        }

        searchGetResults();
        updateMultiSearch();
    });
    rangeTwo.addEventListener('input', (e) => {
        e.preventDefault();

        if (parseInt(rangeTwo.value) - parseInt(rangeOne.value) <= minGap) {
            rangeTwo.value = parseInt(rangeOne.value) + minGap;
            //rangeOne.style.zIndex = 2;
            //rangeTwo.style.zIndex = 1;
        }

        elementInputMaxValue.value = numberWithCommas(rangeTwo.value);
        fillTrackColor(rangeSliderTrack, rangeOne, rangeTwo);

        const updateStateElement = searchState.find(item => item.type === field.key);
        if (!updateStateElement.hasOwnProperty('checked')) {
            updateStateElement.max = rangeTwo.value;
        }
        searchGetResults();
        updateMultiSearch();
    });

    if (!settingsData.searchState.find(item => item.type === field.key)) {
        settingsData.searchState.push({
            type: field.key,
            startMin: minValue,
            startMax: maxValue,
            min: minValue,
            max: maxValue,
        });
    }
}

function setDataRangeInputs(range, rangeValues) {
    for (const key in rangeValues) {

        if (key === 'value') {
            const isFirst = range.classList.contains('search__range-input--one');

            range.setAttribute(key, isFirst ? rangeValues[key].startMinValue : rangeValues[key].startMaxValue);
            continue;
        }

        range.setAttribute(key, rangeValues[key]);
    }
}

// function inputRangeHandler(event) {
//     event.preventDefault();
//     const input = event.target
//
//     if (input.classList.contains('search__range-input--one')) {
//
//     } else {
//
//     }
// }

function fillTrackColor(rangeSliderTrack, rangeOne, rangeTwo) {
    const minValue = rangeOne.min;
    const maxValue = rangeOne.max;
    const percent1 = ((rangeOne.value - minValue) / (maxValue - minValue)) * 100;
    const percent2 = ((rangeTwo.value - minValue) / (maxValue - minValue)) * 100;

    const color1 = 'var(--activeBg)';
    const color2 = 'var(--brand2)';

    const rangeSliderTrackCorrection = 2;
    rangeSliderTrack.style.background = `linear-gradient(to right, ${color1} ${percent1 - rangeSliderTrackCorrection}%, ${color2} ${percent1 - rangeSliderTrackCorrection}%, ${color2} ${percent2 + rangeSliderTrackCorrection}%, ${color1} ${percent2 + rangeSliderTrackCorrection}%)`;
}

function createCheckbox(inputCondition, elementContainer, field) {
    const {searchState} = settingsData;
    const rangeDataInState = searchState.find(state => state.type === field.key);
    const wrapper = createElements('div', ['search__wrapper', 'search__wrapper-checkbox'], elementContainer, 'beforeend', {
        data: 'type',
        value: `${field.key}`
    });

    let searchSwitcher = null;
    if (field.key === 'accessible' || field.key === 'treatmentRoom') {
        searchSwitcher = new Switch(wrapper);
    }

    inputCondition.forEach((value, index) => {
        //if ((field.key === 'accessible' || field.key === 'treatmentRoom') && value === 0) return;

        let elementInputCheckbox;
        if (field.key === 'accessible' || field.key === 'treatmentRoom') {
            searchSwitcher.checkbox.setAttribute('id', `${field.key}_${index}`);
            searchSwitcher.checkbox.setAttribute(`data-${field.key}`, `${value}`);
            searchSwitcher.checkbox.setAttribute(`data-type`, `${field.key}`);
        } else {
            elementInputCheckbox = createElements('input', ['search__option-input', 'search__option-checkbox'], wrapper, 'beforeend', {
                data: 'type',
                value: 'checkbox'
            });
            elementInputCheckbox.setAttribute('id', `${field.key}_${index}`);
            elementInputCheckbox.setAttribute(`data-${field.key}`, `${value}`);
            elementInputCheckbox.setAttribute(`data-type`, `${field.key}`);
        }

        if (rangeDataInState) {
            const isChecked = rangeDataInState.checked.value.indexOf(value);

            if (isChecked !== -1) {
                elementInputCheckbox.setAttribute(`checked`, true);
            }
        }

        let elementLabelCheckbox = null;
        if (field.key === 'accessible' || field.key === 'treatmentRoom') {
            searchSwitcher.slider.setAttribute('data', `${field.key}_${index}`);
        } else {
            elementLabelCheckbox = createElements('label', ['search__option-label'], wrapper, 'beforeend', {
                data: 'for',
                value: `${field.key}_${index}`
            });
        }

        if ((typeof value !== 'number' || value === 0) && elementLabelCheckbox) {

            if (value === 0 && field.key === 'roomNum') value = 'Studio';

            elementLabelCheckbox.classList.add('language-string','search__option__room__text');
            elementLabelCheckbox.setAttribute('data-dictionary', `${value}`);
            elementLabelCheckbox.insertAdjacentHTML('afterbegin', `${changeLangToCurrent(value)}`);
        } else {
            elementLabelCheckbox && elementLabelCheckbox.insertAdjacentHTML('afterbegin', `${value}`);
        }

        if (searchSwitcher) {
            searchSwitcher.listener = checkBoxHandler;
        } else {
            elementInputCheckbox.addEventListener('change', checkBoxHandler);
        }
    });

    const startValue = (rangeDataInState) ? rangeDataInState.checked.value : [];

    if (!settingsData.searchState.find(item => item.type === field.key)) {
        settingsData.searchState.push({
            type: field.key,
            checked: {
                state: [...inputCondition],
                value: startValue
            },
        });
    }
}

export function updateSearchResults() {
    searchGetResults();
}

function createSearchOptionsElements(containerTopWrapper) {
    settingsData.searchResult = [];
    const {fields} = config.features.search.searchConfig;
    const {searchSortState} = config.features.search;
    // console.log(fields);
    // console.log(searchSortState);
    for (const field of fields) {
        let inputCondition = getUniqueUnits(settingsData.allCrmData, field);
        // console.log(inputCondition);
        const displayPrice = config.property.settings.displayPrice;
        const hidePrice = field.key === 'salePrice' && displayPrice === 'hide' && !settingsData.isConferenceHost;
        //console.log(inputCondition.length);
        if (inputCondition.length === 0 || hidePrice) {
            const item = searchSortState.find(state => state.type === field.key);
            const index = searchSortState.indexOf(item);

            index !== -1 && searchSortState.splice(index, 1);
            continue;
        }

        if (field.key === 'facing')
            inputCondition = inputCondition.reduce((arr, item) => {
                // let splited = item.split(/,|-/);
                //
                // splited = [...new Set(splited)];

                // splited.forEach(str => {
                //     const strMod = /^[A-Za-z]*$/.test(str) ? str : facingDictionary()[str].en;
                //
                //     if (arr.indexOf(strMod) === -1) {
                //         arr.push(strMod);
                //     }
                // }

                item.forEach(str => {
                    const strMod = /^[A-Za-z]*$/.test(str) ? str : facingDictionary()[str].en;

                    if (arr.indexOf(strMod) === -1) {
                        arr.push(strMod);
                    }
                });

                return arr;
            }, []);

        // const elementContainer = createElements('div', ['search__option'], isMobile ? document.querySelector('.search__option-container') : containerTopWrapper, 'beforeend', {
        //     data: 'data-type',
        //     value: field.key
        // });

        const elementContainer = createElements('div', ['search__option'], containerTopWrapper, 'beforeend', {
            data: 'data-type',
            value: field.key
        });

        const elementTitle = createElements('h2', ['search__option-title'], elementContainer);

        elementTitle.insertAdjacentHTML('beforeend', `
            <span class="${field.icon} search__option-title--icon"></span>
            <span class="language-string search__option-title--text" data-dictionary="${field.labelKey}">${changeLangToCurrent(field.labelKey)}</span>
        `);



        inputCondition.length > 5 || field?.type === FilterTypes.Range
            ? createRange(inputCondition, elementContainer, field)
            : createCheckbox(inputCondition, elementContainer, field);
    }

    const displayPrice = config.property.settings.displayPrice;
    const lastColumns = (displayPrice === 'hide' && !settingsData.isConferenceHost) ? 1 : 2;
    const mobileDiff = isMobile ? 1 : 0;

    document.documentElement.style.setProperty('--searchGridColumns', `${searchSortState.length - lastColumns - mobileDiff}`);
    document.documentElement.style.setProperty('--searchGridColumnsLast', `${lastColumns}`);
}

export function createSearchResultsSortMenu(searchResultsSort, searchState, params = {}) {
    const searchSortState = searchState || config.features.search.searchSortState;
    const currency = config.localization.currencyLabel;

    switch (currency) {
        case 'EUR':
            document.documentElement.style.setProperty('--currency', `"€"`);
            break;
        case 'USD':
            document.documentElement.style.setProperty('--currency', `"$"`);
            break;
        case 'UAH':
            document.documentElement.style.setProperty('--currency', `"₴"`);
            break;
        case 'NIS':
            document.documentElement.style.setProperty('--currency', `"₪"`);
            break;
    }

    if (!params.hasOwnProperty('disableListener')) {
        searchResultsSort.addEventListener('click', handleSearchSort, false);
    }

    for (const sortType of searchSortState) {
        const displayPrice = config.property.settings.displayPrice;
        const hidePrice = sortType.type === 'salePrice' && displayPrice === 'hide' && !settingsData.isConferenceHost;

        if (hidePrice) continue;

        if (!params.hasOwnProperty('template')) {
            if (isMobile && sortType.type === 'propNum') {
                if (document.querySelector('div[data-sort-type=favorite]')) continue;
            }
        }

        const classNamesItem = (sortType.isActive) ? ['search__sort-item', 'active'] : ['search__sort-item'];
        const div = createElements('div', classNamesItem, searchResultsSort);
        div.setAttribute('data-sort-type', `${sortType.type}`);
        div.setAttribute('data-sort-state', `${sortType.state}`);

        const classNames = (sortType.state === 'minmax') ? ['icon-down'] : ['icon-up'];
        createElements('span', classNames, div);

        if (sortType.icon) {
            createElements('span', [`${sortType.icon}`], div);
        } else {
            const tag = (sortType.text === '#') ? 'span' : 'p';
            const text = (sortType.text === '#') ? `${sortType.text}` : `${changeLangToCurrent(`${sortType.text}`)}`;
            const classNames = (sortType.text === '#') ? '' : ['language-string'];

            const textSort = createElements(tag, classNames, div);
            textSort.setAttribute('data-dictionary', `${sortType.text}`);
            textSort.innerHTML = text;
        }

        switch (sortType.type) {
            case 'totalSpace': {
                // const value = 'm2';
                const value = config.localization.area ? config.localization.area : "m2";
                // const classNames = (value === 'm2') ? ['language-string', 'search__sort-meters'] : ['language-string'];
                const classNames = ['language-string', 'search__sort-meters'];

                const element = createElements('span', classNames, div, 'beforeend', {
                    data: 'data-dictionary',
                    value: value
                });
                element.insertAdjacentHTML('beforeend', `${changeLangToCurrent(value)}`);
                break;
            }
            case 'salePrice': {
                const element = createElements('span', ['language-string', 'search__sort-currency'], div, 'beforeend', {
                    data: 'data-dictionary',
                    value: currency
                });
                element.insertAdjacentHTML('beforeend', `${changeLangToCurrent(currency)}`);
                break;
            }
            default:
                break;
        }
    }
}

/**
 * Check and get unique properties for search inputs
 */

function getUniqueUnits(allCrmData, {key}) {
    return allCrmData.reduce((newArr, data) => {
        if (data.hasOwnProperty(key) && newArr.indexOf(data[key]) === -1 && ['', undefined, null].indexOf(data[key]) === -1) {
            if (key === 'salePrice' && data.status === 'Available') {
                newArr.push(data[key]);
            } else if (key !== 'salePrice') {
                newArr.push(data[key]);
            }
        }

        return newArr.sort((a, b) => a - b);
    }, []);
}

/**
 * Search logic and show results
 */

function sortSearchResults(state, baseSearchArr) {
    return baseSearchArr.filter(data => {
        let dataValue = data[state.type];

        if (isNaN(dataValue)) {

            if (typeof dataValue === 'string'){
                dataValue = dataValue.split(',');
            }

            dataValue = dataValue.map(item => /^[A-Za-z]*$/.test(item) ? item : facingDictionary()[item].en);
        }

        if (data.status === 'Available' && ['', undefined, null].indexOf(dataValue) === -1) {
            if (state.checked) {
                if (Array.isArray(dataValue)) {
                    if(dataValue.length === 0 && state.checked.value.length === 0) {
                        return data;
                    }
                    for (const value of dataValue) {
                        if (state.checked.value.length > 0) {
                            if (state.checked.value.indexOf(value) !== -1) {
                                return data;
                            }
                        } else {
                            if (state.checked?.state.indexOf(value) !== -1) {
                                return data;
                            }
                        }
                    }
                } else {
                    if (state.checked.value.length > 0) {
                        if (state.checked.value.indexOf(dataValue) !== -1) {
                            return data;
                        }
                    } else {
                        //return data;
                        if (state.checked?.state.indexOf(dataValue) !== -1) {
                            return data;
                        }
                    }
                }
            }

            if (state.min <= dataValue && dataValue <= state.max) {
                return data;
            }
        }
    });
}

export function searchGetResults(delay = 0, building, addAndShowResults = true) {
    let {allCrmData, searchResult, searchState} = settingsData;
    const {searchSortState} = config.features.search;
    const activeBuilding = building || Buildings.getActiveBuilding();
    // const crmData = activeBuilding.info.crm_data;
    const crmData = getSelectedBuildingsCrmData(allCrmData);
    // getSelectedBuildingsCrmData(allCrmData);

    // let baseSearchArr = [...allCrmData];
    let baseSearchArr = [...crmData];
    for (const state of searchState) {
        searchResult = sortSearchResults(state, baseSearchArr);
        baseSearchArr = [...searchResult];
    }
    const sortState = searchSortState.find(state => state.isActive);
    searchResult = sortArray(sortState.state, sortState.type, searchResult);

    if (addAndShowResults) {
        showSearchResults(searchResult);

        const timeOut = (delay !== 0) ? (delay + 1.5) * 1000 : delay;
        setTimeout(() => changeSelectionBoxesStatusColor(searchResult, activeBuilding), timeOut);

        settingsData.searchResult = searchResult;
    }

    return searchResult;
}

function getSelectedBuildingsCrmData(allCrmData) {
    const data = new Set();
    allCrmData.forEach(element => {
        /*if (selectedBuildings.has(element.buildingEngineId))*/ data.add(element);
    });

    return data;
}

export function changeSelectionBoxesStatusColor(searchResult, activeBuilding) {
    if (!searchResult) {
        searchResult = settingsData.searchResult
    }
    if (!activeBuilding) {
        activeBuilding = Buildings.getActiveBuilding();
    }

    // const selectionBoxesActiveTower = activeBuilding.all_apartments;
    const selectionBoxesActiveTower = activeBuilding.apartments;

    for (const selBox of selectionBoxesActiveTower) {
        const itemInSearch = searchResult.find(item => item.engineId === selBox.name);

        if (itemInSearch) {
            selBox.userData.isInSearch = true;
            selectionBoxesSetStatusColor(selBox, 'lock');
        } else {
            selBox.userData.isInSearch = false;
            if (settingsData.buildingDestroyed) {
                if (settingsData.currentFloor !== selBox.userData.floor) {
                    selectionBoxesSetStatusColor(selBox, 'unlock');
                }
            } else {
                if (!selBox.userData.isClicked) {
                    selectionBoxesSetStatusColor(selBox, 'unlock');
                }
            }
        }
    }
    updateRenderer();
    markSelectedApartments();
}

export function showSearchResults(searchResult) {
    // Search results counter

    searchResult = searchResult.filter(element => {
        return selectedBuildings.has(element.buildingEngineId);
    });

    const searchResultsCount = document.querySelector('.search__result-count--amount');
    const searchResultsNumber = document.querySelector('.search__result-count--number');

    let text;

    if (Buildings.getBuildingsInfoLength() < 2) {
        text = searchResult.length > 1 ? changeLangToCurrent('apartments found') : changeLangToCurrent('apartment found');
    } else {
        text = changeLangToCurrent('apartments found');
    }


    if (searchResultsNumber && searchResultsNumber.innerText !== text) {
        searchResultsNumber.innerHTML = ` ${text}`;
    }

    if (searchResultsCount) {
        searchResultsCount.innerText = `${searchResult.length}`;
    }

    const sortPanel = document.querySelector('.search__sort');
    if (searchResult.length === 0) {
        sortPanel && sortPanel.classList.add('hide');
    } else {
        sortPanel && sortPanel.classList.remove('hide');
    }

    setResultsInTheHtmlList(searchResult);
}

function setContainerMaxHeight(containerBottom, searchList) {
    const containerMain = document.querySelector('.search__container-main');
    const containerTop = document.querySelector('.search__container-top');
    const sortMenu = document.querySelector('.search__sort');
    const menu = document.querySelector('.aside__container');
    const resultWrapper = document.querySelector('.search__result-wrapper');

    const containerMainHeight = containerMain.getBoundingClientRect().height;
    const containerTopHeight = containerTop.getBoundingClientRect().height;
    const rw = resultWrapper.getBoundingClientRect().height;
    const sm = sortMenu.getBoundingClientRect().height;

    if (isMobile) {
        const resultCount = document.querySelector('.search__result-count');
        const mobileMenu = document.querySelector('.additional-menu__container');

        if (settingsData.isLandscape) {
            const burgerBtn = document.querySelector('.burger__mobile__btn');
            const style = getComputedStyle(containerBottom);
            const searchListMaxHeight = window.innerHeight - (resultCount.clientHeight + sortMenu.clientHeight + burgerBtn.clientHeight + parseInt(style.paddingTop) * 2 + parseInt(style.paddingBottom));

            searchList.setAttribute('style', `max-height: ${searchListMaxHeight}px`);
            return;
        }

        const isMinimized = containerMain.classList.contains('minimize');

        const db = document.body.getBoundingClientRect().height;
        const mm = mobileMenu.getBoundingClientRect().height;

        const searchListMaxHeight = isMinimized
            ? db - rw - sm - mm
            : db - containerTopHeight - rw - sm;

        searchList.setAttribute('style', `max-height: ${searchListMaxHeight}px`);

        return;
    }

    const paddingBottom = (menu && settingsData.isDesktopMode) ? menu.clientHeight : 0;
    const containerBottomHeight = containerMainHeight - containerTopHeight - paddingBottom;

    const searchListMaxHeight = containerBottomHeight - rw - sm;

    searchList.setAttribute('style', `max-height: ${searchListMaxHeight}px`);
}

export function setResultsInTheHtmlList(searchResult, container, params = {}) {
    const searchList = container || document.querySelector('.search__result-list');
    searchList.innerHTML = '';

    // const unitCard = UnitCardClass.findCard()?.html;
    // const engineIdActive = (unitCard) ? unitCard.getAttribute('data-engineid') : '';


    for (let {engineId, propNum, floorNum, roomNum, totalSpace, salePrice, bmbyPropID, facing, accessible, treatmentRoom} of searchResult) {
        const displayPrice = config.property.settings.displayPrice;
        const hidePrice = (salePrice <= 0) || displayPrice === 'hide' && !settingsData.isConferenceHost;

        let propNumLabel = '';

        if ( Buildings.getBuildingsInfoLength() > 1 && (isMobile || isDesktopMode())) {
            config.buildings.find(building => {
                if (building.buildingEngineId === engineId.split('_')[0])
                    propNumLabel = `(${building.buildingLabel})`;
            });
        }

        const unitCard = UnitCardClass.findCard(engineId)?.html;
        const engineIdActive = (unitCard) ? unitCard.getAttribute('data-engineid') : '';

        const classNames = (engineId !== engineIdActive)
            ? ['search__result-item']
            : ['search__result-item', 'active'];

        if (unitCard?.classList.contains('active')) {
            classNames.push('active-card');
        }

        // hidePrice && classNames.push('no-price');

        const searchItem = createElements('li', classNames, searchList);
        searchItem.setAttribute(`data-bmbyPropID`, `${bmbyPropID}`);
        searchItem.setAttribute(`data-engineId`, `${engineId}`);

        if (params.hasOwnProperty('customClass')) {
            searchItem.classList.add(params['customClass']);
        }

        // const number = (propNum.length === 1) ? `00${propNum}` : (propNum.length === 2) ? `0${propNum}` : propNum;
        const price = numberWithCommas(salePrice);

        const priceHTML = (!hidePrice)
            ? `<div class="search__result-item--element">${price}</div>`
            : ``;

        // const exposure = (facing) ? facing.split(',').map(item => facingDictionary()[item].en[0]).join(', ') : '';
        // const exposure = (facing) ? facing.split(',').map(item => /^[A-Za-z]*$/.test(item) ? item : facingDictionary()[item].en) : '';
        const exposure = (facing) ? facing.map(item => /^[A-Za-z]*$/.test(item) ? item : facingDictionary()[item].en) : '';
        const exposureHTML = (exposure) ? `<div class="search__result-item--element">${exposure.map(item => `<span class="language-string" data-dictionary="${item}Short"> ${changeLangToCurrent(`${item}Short`)}</span>`)}</div>` : '';

        let accessibleHTML = '';
        let treatmentRoomHTML = '';
        let accessibleField = false;
        let treatmentRoomField = false;
        const positiveHTML = `<div class="search__result-item--element">V</div>`;
        const negativeHTML = `<div class="search__result-item--element">-</div>`;

        for (let i = 0; i < config.features.search.searchConfig.fields.length; i++) {
            if (config.features.search.searchConfig.fields[i].hasOwnProperty('accessible')) accessibleField = true;
            if (config.features.search.searchConfig.fields[i].hasOwnProperty('treatmentRoom')) treatmentRoomField = true;
        }

        if (accessibleField) {
            if (!!accessible) {
                accessibleHTML = positiveHTML;
            } else {
                accessibleHTML = negativeHTML;
            }
        }

        if (treatmentRoomField) {
            if (!!treatmentRoom && treatmentRoomField) {
                treatmentRoomHTML = positiveHTML;
            } else {
                treatmentRoomHTML = negativeHTML;
            }
        }

        const isInFavorite = getObjectFromLocalStorage(engineId);
        const toggleClassFav = isInFavorite ? 'icon-favorite_selected' : 'icon-unselected';
        const iconFavorite = `<span class="search__favorites-icon ${toggleClassFav}" data-favorite="favorite"></span>`;
        const favoriteHTML = !isMobile ? `<div class="search__result-item--element">${iconFavorite}</span></div>` : '';

        if (params.hasOwnProperty('template')) {
            const favTemp = params.template['favorite'] ? favoriteHTML : '';
            const propNumTemp = params.template['aptNumber'] ? `<div class="search__result-item--element">${isMobile && params.template['favorite'] ? iconFavorite : ''}<span>${propNum}${propNumLabel}</span></div>` : '';
            const exposureTemp = params.template['exposure'] ? exposureHTML : '';
            const floorNumTemp = params.template['floorNumber'] ? `<div class="search__result-item--element">${floorNum}</div>` : '';

            let roomNumTemp;

            if (params.template['roomNumber']) {
                if (roomNum === 0) {
                    roomNumTemp = `<div class="search__result-item--element language-string" data-dictionary="Studio">${changeLangToCurrent('Studio')}</div>`;
                } else {
                    roomNumTemp = `<div class="search__result-item--element">${roomNum}</div>`;
                }
            } else {
                roomNumTemp = '';
            }

            // const roomNumTemp = params.template['roomNumber'] ? `<div class="search__result-item--element">${roomNum}</div>` : '';

            const totalSpaceTemp = params.template['totalSpace'] ? `<div class="search__result-item--element">${totalSpace}</div>` : '';
            const priceTemp = params.template['price'] ? priceHTML : '';

            searchItem.insertAdjacentHTML('afterbegin', `
            ${favTemp}
            ${propNumTemp}
            ${exposureTemp}
            ${floorNumTemp}
            ${roomNumTemp}
            ${totalSpaceTemp}
            ${priceTemp}
            `);

        } else {
            let roomNumHtml;
            if (roomNum === 0) {
                roomNumHtml = `<div class="search__result-item--element language-string" data-dictionary="Studio">${changeLangToCurrent('Studio')}</div>`;
            } else {
                roomNumHtml = `<div class="search__result-item--element">${roomNum}</div>`;
            }

            searchItem.insertAdjacentHTML('afterbegin', `
            ${favoriteHTML}
            <div class="search__result-item--element">${isMobile ? iconFavorite : ''}<span>${propNum}${propNumLabel}</span></div>
            ${exposureHTML}
            <div class="search__result-item--element">${floorNum}</div>
            ${roomNumHtml}
            <div class="search__result-item--element">${totalSpace}</div>
            ${priceHTML}
            ${accessibleHTML}
            ${treatmentRoomHTML}
          `);
        }
        searchList.appendChild(searchItem);
    }
}

/**
 * Search handlers
 */

let clickSearchTimer = null;

export async function openSearchHandler(timeout) {
    const isSearchOpened = document.querySelector('.search__container-main');
    if (isSearchOpened) return;

    // if (clickSearchTimer !== null) {
    //     clearTimeout(clickSearchTimer);
    // }

    // clickSearchTimer = setTimeout(function () {
        let delay = timeout ?? 0;
        const unitCard = UnitCardClass.findCard()?.html;

        if (settingsData.buildingDestroyed && !settingsData.switchLang)
            unitCard && UnitCardClass.closeMultipleCards();

        // if (settingsData.activeViewMode === ViewMode.Orbit) {
        //     // viewModesSwitching(ViewMode.Cylinder);
        //     // delay = 2;
        // } else if (settingsData.buildingDestroyed && !settingsData.switchLang) {
        //     unitCard && UnitCardClass.closeMultipleCards();
        //
        //     // bombButtonInitActionHandler();
        //     // delay = 2;
        // }

        createSearchModule();
        hideTooltip();
        searchGetResults(delay);
        // createMultipleSearch();
        await animations(delay, 'open');
        changeCardPositionWhenSearchOpen();
    // }, 500);
}

function flexibleSearchHandle(event) {
    const {searchState} = settingsData;
    let searchResult = settingsData.searchResult;
    const value = event.target.value.trim();
    const states = [...searchState.map(item => item.type), 'modelName'];

    if (value) {
        searchResult = searchResult.reduce((newArr, result) => {
            states.forEach(state => {
                const dataItem = result[state];

                if (state === 'facing') {
                    const dict = facingDictionary();
                    const lang = getCurrentLang();
                    const facingArr = dataItem.map(face => dict[face][lang].toLowerCase());

                    if (facingArr.indexOf(value.toLowerCase()) !== -1) {
                        if (newArr.indexOf(result) === -1) {
                            newArr.push(result);
                        }
                    }
                } else {
                    if (dataItem === value || dataItem === +value) {
                        if (newArr.indexOf(result) === -1) {
                            newArr.push(result);
                        }
                    }
                }
            });

            return newArr;

        }, []);
    }

    showSearchResults(searchResult);
    changeSelectionBoxesStatusColor(searchResult, null);
}

function checkBoxHandler({target}) {
    const {searchState} = settingsData;
    const type = target.getAttribute('data-type');
    let value = target.getAttribute(`data-${type.toLowerCase()}`);

    value = (isNaN(+value)) ? value : +value;

    const stateElement = searchState.find(data => data.type === type);
    const indexValue = stateElement.checked.value.indexOf(value);

    // clearInputFlexible();

    if ((type === 'accessible' || type === 'treatmentRoom') && target.checked) value = 1;

    (target.checked && indexValue === -1)
        ? stateElement.checked.value.push(value)
        : stateElement.checked.value.splice(indexValue, 1);

    searchGetResults();
    updateMultiSearch();
}

export function changeActiveCardWhenBuildingClick(clickedSelectionBox, switchCard) {
    const unitCard = UnitCardClass.findCard()?.html;


    const dataEngineID = clickedSelectionBox.name;
    const searchItem = document.querySelector(`li.search__result-item:not(.similar-item)[data-engineid=${dataEngineID}]`);

    const searchItemActiveCard = document.querySelector('.search__result-item:not(.similar-item).active-card');

    if (searchItemActiveCard) {
        !switchCard && searchItemActiveCard.classList.remove('active-card');
        if (!cardsData.multiplyCards && UnitCardClass.cards.length === 1 || switchCard) {
            searchItemActiveCard.classList.remove('active');
        } else if (cardsData.multiplyCards && UnitCardClass.cards.length > 1 || switchCard) {
            searchItemActiveCard.classList.remove('active');
        }
    }

    if (!searchItem)  {
        return;
    }

    searchItem.classList.add('active');
    searchItem.classList.add('active-card');

    searchItem.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
    });
}

function clearInputFlexible() {
    const input = document.querySelector('.search__input-flexible');

    if (input.value.length > 0) {
        input.value = '';

        searchGetResults(0);
        updateMultiSearch();
    }
}

// function handleCardHover(event) {
//     const target = event.target.closest('li');
//     Tooltip.target = target;
//     const buildingName = target?.getAttribute('data-engineid').split('_')[0];
//     config.buildings.find(building => {
//         if (building.buildingEngineId === buildingName) {
//             if (building.buildingLabel.split(' ').length < 2) {
//                 Tooltip.content = `<span data-dictionary="building" class="language-string">${changeLangToCurrent('building')} ${building.buildingLabel}</span>`;
//             } else {
//                 Tooltip.content = building.buildingLabel;
//             }
//
//         }
//     });
// }

export async function handleCardSelect(event) {
    if (settingsData.bombBlock || userPrevent() || settingsData.activeModeSwitching) return;

    settingsData.activeModeSwitching = true;

    let target = event.target.closest('.search__result-item');
    let dataEngineID = target.getAttribute('data-engineid');
    const targetedBuildingName = dataEngineID.split('_')[0];

    if (target.classList.contains('search__result-list')) return;

    if ((Buildings.activeBuilding.name !== targetedBuildingName) && !projectMode.LiteMode.modeIs('picture')) {
        if (settingsData.buildingDestroyed) await projectMode.FloorPlan.exitFromMode();
        await projectMode.Cylinder.switchBuilding(targetedBuildingName, dataEngineID);
    }

    const isFavorite = target.getAttribute('data-favorite') === 'favorite';

    if (!dataEngineID) {
        target = target.closest('.search__result-item');
        dataEngineID = target.getAttribute('data-engineid');
    }

    if (isFavorite && dataEngineID) {
        handleFavoriteLogic(event, 'searchClick');
        return;
    }

    const unitCard = UnitCardClass.findCard()?.html;
    hoverOutPreviousSelection(unitCard);


    const {selectedMesh} = findSelectionAndCrmData(dataEngineID);
    target.classList.add('active');
    markSelectedApartments(dataEngineID);
    flatClick(selectedMesh);

    // return ;
    settingsData.activeModeSwitching = false;

    //
    // if (!cardsData.multiplyCards){
    //
    //     const openedCard = UnitCardClass.findCard();
    //
    //     if (!openedCard){
    //
    //         isMobile && !settingsData.isLandscape && removeSearchContainer();
    //
    //         const {selectedMesh} = findSelectionAndCrmData(dataEngineID);
    //         target.classList.add('active');
    //         markSelectedApartments(dataEngineID);
    //         flatClick(selectedMesh);
    //
    //     } else {
    //         const searchItemActive = document.querySelector('.search__result-item.active');
    //         searchItemActive.classList.remove('active');
    //
    //         const activeMesh = findSelectionAndCrmData(openedCard.engineId).selectedMesh;
    //         activeMesh.userData.isClicked = false;
    //         selectionBoxesSetStatusColor(activeMesh, 'hoverOut');
    //
    //         const {selectedMesh} = findSelectionAndCrmData(dataEngineID);
    //         target.classList.add('active');
    //         markSelectedApartments(dataEngineID);
    //         flatClick(selectedMesh);
    //     }
    //
    // } else {
    //
    //     if (UnitCardClass.cards.length > 1) {
    //
    //
    //
    //
    //     } else {
    //
    //         const {selectedMesh} = findSelectionAndCrmData(dataEngineID);
    //         target.classList.add('active');
    //         markSelectedApartments(dataEngineID);
    //         flatClick(selectedMesh);
    //
    //     }
    //
    //
    //
    //
    // }
    //
    //
    //
    //
    //
    //
    //
    //
    // return ;
    //
    //
    //
    // const searchItemActive = document.querySelector('.search__result-item.active');
    //
    // // let target = event.target;
    // // let dataEngineID = target.getAttribute('data-engineId');
    // // const isFavorite = target.getAttribute('data-favorite') === 'favorite';
    //
    // if (!dataEngineID) {
    //     target = target.closest('.search__result-item');
    //     dataEngineID = target.getAttribute('data-engineId');
    // }
    //
    // if (isFavorite && dataEngineID) {
    //     handleFavoriteLogic(event, 'searchClick');
    //     return;
    // }
    //
    // /**
    //  * click on search when card has already opened
    //  */
    // if (searchItemActive) {
    //     const {selectedMesh} = findSelectionAndCrmData(dataEngineID);
    //
    //     const openedCard = UnitCardClass.findCard(dataEngineID);
    //     if (openedCard) {
    //         return;
    //     }
    //
    //     const unavailableCard = UnitCardClass.findCard(false, 'unavailable');
    //     if (unavailableCard && unavailableCard.html.classList.contains('active')) {
    //         const {selectedMesh} = findSelectionAndCrmData(unavailableCard.engineId);
    //         selectedMesh.userData.isClicked = false;
    //         selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
    //         updateRenderer();
    //     }
    //
    //     if (UnitCardClass.cards.length > 0) {
    //         const searchItemActiveList = document.querySelectorAll('.search__result-item.active');
    //         let prevElem, prevSelectionBox;
    //         searchItemActiveList.forEach(elem => {
    //             if (elem.classList.contains('active-card')) {
    //                 prevElem = elem;
    //             }
    //
    //             if (prevElem) {
    //                 prevElem.classList.remove('active-card');
    //
    //                 if (UnitCardClass.cards.length > 1 || !cardsData.multiplyCards) {
    //                     prevElem.classList.remove('active');
    //                     const prevId = prevElem.getAttribute('data-engineid');
    //                     const {selectedMesh} = findSelectionAndCrmData(prevId);
    //                     prevSelectionBox = selectedMesh;
    //
    //                     prevSelectionBox.userData.isClicked = false;
    //                     selectionBoxesSetStatusColor(prevSelectionBox, 'hoverOut');
    //                     updateRenderer();
    //                 }
    //
    //                 // hover out unavailable flat
    //             }
    //
    //         });
    //
    //         target.classList.add('active');
    //         target.classList.add('active-card');
    //
    //         settingsData.lastClickedFlat = selectedMesh;
    //
    //             if (settingsData.buildingDestroyed) {
    //                 await moveAroundTheFloors(dataEngineID);
    //             } else {
    //                 rotation_to_flat(selectedMesh);
    //             }
    //
    //         markSelectedApartments(dataEngineID);
    //
    //         flatClick(selectedMesh);
    //
    //         target.classList.add('active');
    //         target.classList.add('active-card');
    //
    //         updateRenderer();
    //
    //         return;
    //     }
    // }
    //
    // const unavailableCard = UnitCardClass.findCard(false, 'unavailable');
    // if (unavailableCard && !cardsData.multiplyCards) {
    //     const {selectedMesh} = findSelectionAndCrmData(unavailableCard.engineId);
    //     selectedMesh.userData.isClicked = false;
    //     selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
    //     updateRenderer();
    // }
    //
    // target.classList.add('active');
    // target.classList.add('active-card');
    //
    // if (cardsData.openedCards.length === 0) {
    //     isMobile && !settingsData.isLandscape && removeSearchContainer();
    //
    //     const {selectedMesh} = findSelectionAndCrmData(dataEngineID);
    //     markSelectedApartments(dataEngineID);
    //     flatClick(selectedMesh);
    // }
}

export function toggleClassFavoritesInSearch(event, isInFavorite, similarSearch) {
    if (event.target) {
        setActiveClassHandler(event);
    }

    if (!event) {
        event = document.querySelector('.search__result-item.active-card span[data-favorite=favorite]');
    } else if (similarSearch) {
        event = event;
    } else {
        event = event.target;
    }

    const isNotSelected = event.classList.contains('icon-unselected');

    if (isNotSelected && !isInFavorite) {
        event.classList.remove('icon-unselected');
        event.classList.add('icon-favorite_selected');
    } else {
        event.classList.add('icon-unselected');
        event.classList.remove('icon-favorite_selected');
    }
}

export function markSelectedApartments(engineIdActive) {
    const target = document.querySelector('.search__result-item.active');

    if (!target) return;

    const engineId = (!engineIdActive) ? target.getAttribute('data-engineid') : engineIdActive;
    const {selectedMesh} = findSelectionAndCrmData(engineId);
    if (projectMode.LiteMode.isActive() && !projectMode.LiteMode.modeIs('picture') || !projectMode.LiteMode.isActive()) {
        settingsData.lastClickedFlat = selectedMesh;
        selectedMesh.userData.isClicked = true;
        selectionBoxesSetStatusColor(selectedMesh, 'click');
        updateRenderer();
    }
    target.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
    });
    settingsData.switchLang = false;
}

function handleSearchSort(event) {
    let target = event.target;
    let sortAttribute = target.getAttribute('data-sort-type');
    let {searchResult} = settingsData;
    const {searchSortState} = config.features.search;

    if (!sortAttribute) {
        target = target.parentNode;
        sortAttribute = target.getAttribute('data-sort-type');

        if (!sortAttribute) return;
    }

    const arrowsUp = document.querySelectorAll('span[class=icon-up]');
    arrowsUp.forEach(arrow => {
        const parent = arrow.parentNode;

        if (parent !== target) {
            arrow.classList.remove('icon-up');
            arrow.classList.add('icon-down');

            parent.setAttribute('data-sort-state', 'minmax');
        }
    });

    const items = document.querySelectorAll('.search__sort-item');
    items.forEach(item => {
        if (item === target) {
            !item.classList.contains('active') && item.classList.add('active');
        } else {
            item.classList.contains('active') && item.classList.remove('active');
        }
    });

    const dataValue = target.getAttribute('data-sort-state');
    searchSortState.forEach(item => item.isActive = false);
    const stateItem = searchSortState.find(item => item.type === sortAttribute);

    stateItem.state = dataValue === 'minmax' ? 'maxmin' : 'minmax';

    const arrowClassName = dataValue === 'minmax' ? `span[class=icon-down]` : `span[class=icon-up]`;

    const arrow = target.querySelector(`${arrowClassName}`);
    arrow.classList.toggle('icon-down');
    arrow.classList.toggle('icon-up');

    stateItem.isActive = true;
    target.setAttribute('data-sort-state', `${stateItem.state}`);

    searchResult = sortArray(stateItem.state, sortAttribute, searchResult);
    console.log('handleSearchSort')
    setTimeout(() => markSelectedApartments(), 500);

    setResultsInTheHtmlList(searchResult);
}

export function sortArray(value, type, sortArray) {
    const copyArray = sortArray.slice();

    switch (type) {
        case 'facing': {
            const lang = getCurrentLang();

            copyArray.sort((a, b) => a[type][0]?.localeCompare(b[type][0], `${lang}`, {ignorePunctuation: true}));
            const checkEmptyFacing = copyArray.some(el => el.facing.length === 0);

            if (checkEmptyFacing){
                copyArray.sort((prev,next) => next.facing.length - prev.facing.length);
            }

            return value === 'minmax' ? copyArray : copyArray.reverse();
        }
        case 'favorite': {
            return sortFavorites(value, copyArray);
        }
        case 'propNum': {

            return value === 'minmax' ? copyArray.reverse() : copyArray;

        }
        default: {
            return value === 'minmax'
                ? copyArray.sort((a, b) => b[type] - a[type])
                : copyArray.sort((a, b) => a[type] - b[type]);
        }
    }

}

function sortFavorites(condition, sortArray) {
    let localFavorites;
    if (typeof window.localStorage !== 'undefined' ) {
        localFavorites = JSON.parse(localStorage.getItem('favorites'));
    } else {
        localFavorites = JSON.parse(getCookie('favorites'));
    }

    if (!localFavorites || localFavorites?.length === 0) return sortArray;

    return sortArray.reduce((newResultsArray, item) => {
        const isInFavorites = localFavorites.find(fav => fav.engineId === item.engineId);

        if (newResultsArray.indexOf(item) === -1) {
            if (condition === 'maxmin') {
                isInFavorites ? newResultsArray.unshift(item) : newResultsArray.push(item);
            } else {
                !isInFavorites ? newResultsArray.unshift(item) : newResultsArray.push(item);
            }

        }

        return newResultsArray;
    }, []);
}

function resetFilter() {
    const {searchState} = settingsData;

    for (const state of searchState) {
        if (state.checked) {
            const checkboxes = document.querySelectorAll(`input[data-type=${state.type}]`);

            state.checked.value = [];

            checkboxes.forEach(checkbox => checkbox.checked = false);
        } else {
            const container = document.querySelector(`div[data-type=${state.type}]`);
            const inputMinValue = container.querySelector('.search__option-input--min');
            const inputMaxValue = container.querySelector('.search__option-input--max');
            const ranges = document.querySelectorAll(`.search__range-input--${state.type}`);
            const rangeSliderTrack = ranges[0].parentNode.querySelector('.search__range-slider-track');
            let rangeOne, rangeTwo;

            state.max = state.startMax;
            state.min = state.startMin;

            ranges.forEach(range => {
                if (range.classList.contains('search__range-input--one')) {
                    rangeOne = range;
                    range.setAttribute('value', state.min);
                    range.value = state.min;
                    inputMinValue.value = numberWithCommas(state.min);
                } else {
                    rangeTwo = range;
                    range.setAttribute('value', state.max);
                    range.value = state.max;
                    inputMaxValue.value = numberWithCommas(state.max);
                }
            });
            fillTrackColor(rangeSliderTrack, rangeOne, rangeTwo);
        }
    }

    searchGetResults();
    updateMultiSearch();
    console.log('Clear filter');
}

function inputFocusStyle(event) {
    const buttonClear = document.querySelector('.search__button-clear');
    const containerTopHeader = document.querySelector('.search__top-header');

    switch (event.type) {
        case 'focus': {
            containerTopHeader && containerTopHeader.classList.add('border-bottom');
            buttonClear && buttonClear.classList.add('icon-close');
            break;
        }
        case 'blur': {
            containerTopHeader && containerTopHeader.classList.remove('border-bottom');
            buttonClear && buttonClear.classList.remove('icon-close');
            break;
        }
    }
}

export function toggleResultsList(action) {
    const btn = document.querySelector('.search__button-results');
    const containerBottom = document.querySelector('.search__container-bottom');
    const searchList = document.querySelector('.search__result-list');

    if (!btn) return;

    const span = btn.childNodes[0];
    const isOpened = containerBottom.classList.contains('opened');

    if (action === 'close' && !isOpened) return;

    setContainerMaxHeight(containerBottom, searchList);

    if (settingsData.isLandscape) {
        if (isOpened) {
            gsap.to(containerBottom, {
                opacity: 0,
                onStart: () => {
                    span.classList.remove('icon-building');
                    span.classList.add('icon-list1');
                },
                onComplete: () => {
                    containerBottom.classList.remove('opened');
                }
            });
        } else {
            gsap.to(containerBottom, {
                opacity: 1,
                onStart: () => {
                    span.classList.remove('icon-list1');
                    span.classList.add('icon-building');
                },
                onComplete: () => {
                    containerBottom.classList.add('opened');
                }
            });
        }

        return;
    }

    if (isOpened) {
        gsap.to(containerBottom, {
            duration: 0.5,
            top: '100%',
            onStart: () => {
                span.classList.remove('icon-building');
                span.classList.add('icon-list1');
            },
            onComplete: () => {
                containerBottom.classList.remove('opened');
                settingsData.searchListOpened = false;
            }
        });
    } else {
        gsap.to(containerBottom, {
            duration: 0.5,
            top: '0',
            onStart: () => {
                span.classList.remove('icon-list1');
                span.classList.add('icon-building');
            },
            onComplete: () => {
                containerBottom.classList.add('opened');
                settingsData.searchListOpened = true;
            }
        });
    }

    const rightNavBar = document.querySelector('.right-nav-bar');

    if (isMobile) {
        if (+rightNavBar.style.zIndex === 4) {
            rightNavBar.style.zIndex = 2;
        }
    }
}

function mobileCloseSearch() {
    console.log('close search action mobile landscape')
    // minimizeSearchContainer();
    // removeSearchContainer('minimize');
}

export function mobileHandleSearch(event) {
    const parentContainer = document.querySelector('.search__container-main');

    if (!parentContainer) return;

    const isContainerMinimized = parentContainer.classList.contains('minimize');

    const isEvent = ['swiped-down', 'swiped-left', 'swiped-right'].indexOf(event.type) !== -1;
    let action = (isEvent) ? 'minimize' : 'maximize';

    if (event.type === 'swiped-up' && !isContainerMinimized) {
        action = 'open-full';
    }

    const delay = (event.hasOwnProperty('delay')) ? event.delay : 0;

    animations(delay, action, parentContainer);
}

let keyPressed = false;
let range;
let stateValue;
let prevValue;

function handleRangeInputs(event) {
    const target = event.target;
    const type = target.getAttribute('data-type');
    const ranges = document.querySelectorAll(`.search__range-input--${type}`);
    const {searchState} = settingsData;

    const currentState = searchState.find(item => item.type === type);

    // let range;
    // let stateValue;
    // let prevValue;

    ranges.forEach(item => {
        if (item.classList.contains('search__range-input--one') && target.classList.contains('search__option-input--min')) {
            range = item;
            stateValue = 'min';
        } else if (item.classList.contains('search__range-input--two') && target.classList.contains('search__option-input--max')) {
            range = item;
            stateValue = 'max';
        }
    });

    const rangeTrack = range.parentNode.querySelector('.search__range-slider-track');
    const rangeOne = range.parentNode.querySelector('.search__range-input--one');
    const rangeTwo = range.parentNode.querySelector('.search__range-input--two');

    const reg = new RegExp('^[0-9]+$');

    switch (event.type) {
        case 'keyup': {
            if (event.key === 'Enter') {
                setInputValue();
                document.activeElement.blur();
            }

            break;
        }
        case 'focus': {
            if (isMobile) {
                settingsData.stopWindowResizeEvents = true;
            }
            prevValue = target.value;
            target.value = '';
            keyPressed = false;
            break;
        }
        case 'focusout': {
            if (!target.value) {
                target.value = prevValue.replace(/,/g, '');
            }

            if (isMobile) {
                setTimeout(() => {
                    settingsData.stopWindowResizeEvents = false;
                }, 200);
            }
            !keyPressed && setInputValue();
            break;
        }
        case 'change': {
            input();
            break;
        }
    }

    function input() {
        if (!reg.test(target.value)) {
            console.log('-=Enter only digits [0-9]=-');
            target.value = prevValue.replace(/,/g, '');
            document.activeElement.blur();
            return;
        }

        if (range === rangeOne && +target.value < +range.getAttribute('min')) {
            target.value = +range.getAttribute('min');
        } else if (range === rangeTwo && +target.value > +range.getAttribute('max')) {
            target.value = +range.getAttribute('max');
        }
    }

    function setInputValue() {
        keyPressed = true;
        if (!target.value) {
            range.value = currentState[stateValue];
            target.value = numberWithCommas(`${currentState[stateValue]}`);
        }

        if (range === rangeOne && +target.value >= +rangeTwo.value) {
            target.value = +rangeTwo.value;
        } else if (range === rangeTwo && +target.value <= +rangeOne.value) {
            target.value = +rangeOne.value;
        }

        range.value = +target.value;
        currentState[stateValue] = +target.value;
        target.value = numberWithCommas(target.value);
        range.setAttribute('value', target.value);

        if (parseInt(rangeTwo.value) - parseInt(rangeOne.value) <= 0) {
            if (range === rangeOne) {
                rangeOne.style.zIndex = 2;
                rangeTwo.style.zIndex = 1;
            } else {
                rangeOne.style.zIndex = 1;
                rangeTwo.style.zIndex = 2;
            }
        }

        fillTrackColor(rangeTrack, rangeOne, rangeTwo);
        searchGetResults();
        updateMultiSearch();
    }
}

/**
 * Close and remove search block
 */

export async function removeSearchContainer(action, option) {
    const parentContainer = document.querySelector('.search__container-main');
    if (parentContainer) {
        // const buttonClose = document.querySelector('.search__button-close');
        // const inputSearch = document.querySelector('.search__input-flexible');
        // const buttonClear = document.querySelector('.search__button-clear');
        const searchList = document.querySelector('.search__result-list');
        const searchResultsSort = document.querySelector('.search__sort');
        const buttonReset = document.querySelector('.search__button-reset');
        const buttonResults = document.querySelector('.search__button-results');
        const containerBottom = document.querySelector('.search__container-bottom');

        //Remove listeners
        // buttonClose.removeEventListener('click', removeSearchContainer, false);
        // buttonReset.removeEventListener('click', resetFilter, false);
        // buttonClear.removeEventListener('click', clearInputFlexible, false);
        buttonResults.removeEventListener('click', toggleResultsList, false);
        // inputSearch.removeEventListener('input', flexibleSearchHandle, false);
        // inputSearch.removeEventListener('focus', inputFocusStyle, false);
        // inputSearch.removeEventListener('blur', inputFocusStyle, false);
        searchList.removeEventListener('click', handleCardSelect, false);
        searchResultsSort.removeEventListener('click', handleSearchSort, false);

        if (isMobile) {
            if (settingsData.isLandscape) {
                (getCurrentLangDirection() === 'ltr')
                    ? parentContainer.addEventListener('swiped-left', mobileCloseSearch, false)
                    : parentContainer.addEventListener('swiped-right', mobileCloseSearch, false);
            } else {
                // parentContainer.removeEventListener('swiped-down', mobileCloseSearch, false);
                parentContainer.removeEventListener('swiped-down', mobileHandleSearch, false);
                parentContainer.removeEventListener('swiped-up', mobileHandleSearch, false);
            }
            // containerMain.addEventListener('swiped-up', );
        }
        // else if (settingsData.isDesktopMode) {
        //     parentContainer.removeEventListener('swiped-right', mobileCloseSearch, false);
        // }

        //Set colors on building selectionBoxes
        const activeBuilding = Buildings.getActiveBuilding();

        activeBuilding.apartments.forEach(item => {
            if (settingsData.buildingDestroyed) {
                if (item.userData.floor !== settingsData.currentFloor && item.userData.isActive) {
                    selectionBoxesSetStatusColor(item, 'unlock');
                }
            } else {
                if (item.userData.isActive) {
                    selectionBoxesSetStatusColor(item, 'unlock');
                }
            }
        });

        updateRenderer();

        //Set color if Unit Card is open and show selected apartment
        const unitCard = UnitCardClass.findCard()?.html;
        if (unitCard && option !== 'building-switcher') {
            const engineId = unitCard.getAttribute('data-engineid');
            const activeApartment = activeBuilding.apartments.find(apt => apt.name === engineId);
            selectionBoxesSetStatusColor(activeApartment, 'click');
            updateRenderer();
        }

        //Remove search container without animation
        if (action === 'immediately') {
            parentContainer.remove();
            isMobile && containerBottom.remove();
            // return new Promise(resolve => resolve(true));
        }

        //Close search panel with animation
       await animations(0, 'close', parentContainer);
    }

    // return new Promise(resolve => resolve(true));
}

/**
 * Animations
 */

function animations(delay = 0, action, container) {
    const searchAnimations = [];
    const dir = getCurrentLangDirection();
    const tl = gsap.timeline();
    const listSearch = document.querySelector('.search__result-list');
    const sideBarContainer = document.querySelector('.aside__container');
    const menuMobile = document.querySelector('.additional-menu__container');
    const containerBottom = document.querySelector('.search__container-bottom');
    const unitCard = UnitCardClass.findCard()?.html;

    let containerPosition = 0;

    if (sideBarContainer && !isMobile) {
        containerPosition = +sideBarContainer.getAttribute('data-initial-width');
    }else if (menuMobile) {
        containerPosition = getPositionValueMobileContainer();
    }

    const importantDirection = isDesktopMode();

    let direction = (isMobile && !settingsData.isLandscape)
        ? 'bottom'
        : (isMobile && settingsData.isLandscape)
            ? (dir === 'rtl') ? 'left' : 'right'
            : (dir === 'rtl') ? 'right' : 'left';

    if (importantDirection) {
        direction = 'right';
        containerPosition = 0;
    }

    if (isMobile && settingsData.isLandscape) {
        containerPosition = 0;
        rightNavMenuZIndexChange(4);
    }

    switch (action) {
        case 'close': {
            const closePromise = new Promise(resolve => {
                gsap.to(container, {
                    duration: 0.4,
                    [direction]: '-30%',

                    // onStart: searchResizeCanvas,

                    onComplete: () => {
                        container && container.remove();
                        isMobile && containerBottom && containerBottom.remove();
                        changeCardPositionWhenSearchOpen();
                        // searchResizeCanvas();
                        resolve(true);
                    }
                });
            });

            // settingsData.animationsList.push(closePromise);
            searchAnimations.push(closePromise);

            return Promise.all(searchAnimations);
        }
        case 'minimize': {
            const minimizePromise = new Promise(resolve => {
                const position = (!settingsData.isLandscape)
                    ? -(container.clientHeight - menuMobile.clientHeight)
                    : -container.clientWidth;

                gsap.to(container, {
                    duration: 0.4,
                    [direction]: `${position}px`,

                    onStart: () => {
                        if (container.classList.contains('open-full')) {
                            container.classList.remove('open-full');
                        }

                        if (!container.classList.contains('minimize')) {
                            container.classList.add('minimize');
                        }
                        // settingsData.isLandscape && searchResizeCanvas();
                        // settingsData.isLandscape && canvasResize();

                        settingsData.isLandscape && toggleResultsList('close');
                    },
                    onComplete: () => {
                        const searchBottomContainer = document.querySelector('.search__container-bottom');

                        if (searchBottomContainer) {
                            const resultList = document.querySelector('.search__result-list');
                            const isOpened = searchBottomContainer.classList.contains('opened');

                            isOpened && setContainerMaxHeight(searchBottomContainer, resultList);
                        }
                        canvasResize();
                        resolve(true);
                    }
                });
            });

            // settingsData.animationsList.push(minimizePromise);
            searchAnimations.push(minimizePromise);

            return;
        }
        case 'maximize': {
            const position = getPositionValueMobileContainer();
            UnitCardClass.closeMobileCard();

            const maximizePromise = new Promise(resolve => {
                const position = getPositionValueMobileContainer();


                gsap.to(container, {
                    duration: 0.4,
                    delay,
                    [direction]: `${position}px`,

                    onStart: () => {
                        if (container.classList.contains('minimize')) {
                            container.classList.remove('minimize');
                        }
                        // settingsData.isLandscape && searchResizeCanvas();
                        // settingsData.isLandscape && canvasResize();
                    },
                    onComplete: () => {
                        setContainerMaxHeight(
                            document.querySelector('.search__container-bottom'),
                            document.querySelector('.search__result-list'));
                        canvasResize();
                        resolve(true);
                    }
                });
            });

            // settingsData.animationsList.push(maximizePromise);
            searchAnimations.push(maximizePromise);


            return;
        }
        case 'open-full': {
            const openFullPromise = new Promise(resolve => {
                const position = (!settingsData.isLandscape) ? menuMobile.clientHeight : 0;

                gsap.to(container, {
                    duration: 0.4,
                    [direction]: `${position}px`,

                    onComplete: () => {
                        if (!container.classList.contains(action)) {
                            container.classList.add(action);
                        }

                        setContainerMaxHeight(
                            document.querySelector('.search__container-bottom'),
                            document.querySelector('.search__result-list'));
                        canvasResize();
                        resolve(true);
                    }
                });


            });

            // settingsData.animationsList.push(openFullPromise);
            searchAnimations.push(openFullPromise);

            return;
        }
    }

    if (isMobile && settingsData.isLandscape && unitCard) {
        delay = 1;
        UnitCardClass.closeMultipleCards();
    }

    const searchPromise = new Promise(resolve => {
        tl.to('.search__container-main', {
            duration: 0.4,
            delay: delay,
            [direction]: containerPosition,

            onStart: () => {
                renderUpdateValuesOnDemand(false);
                // const timeOut = (isMobile && unitCard) ? 700 : 0;
                // isMobile && unitCard && closeCard(CardTypes.Unit);

                // setTimeout(searchResizeCanvas, timeOut);
                // searchResizeCanvas();
                if (projectMode.LiteMode.isActive()) {
                    !projectMode.LiteMode.modeIs('picture') && canvasResize();
                } else {
                    canvasResize();
                }
            },
            onComplete:() => {
                // userPrevent(false);
                resolve(true);
            }
        });
    });

    // settingsData.animationsList.push(searchPromise);
    searchAnimations.push(searchPromise);

    const searchContainerPromise = new Promise(resolve => {
        tl.fromTo(['.search__container-top', '.search__container-bottom'], {
                opacity: 0,
            },
            {
                duration: 0.2,
                opacity: 1,
                onComplete: () => {
                    resolve(true);
                }
        });
    });

    // settingsData.animationsList.push(searchContainerPromise);
    searchAnimations.push(searchContainerPromise);


    const searchListPromise = new Promise(resolve => {
        listSearch.childNodes.forEach(item => {
            tl.fromTo(item,
                {
                    opacity: 0,
                },
                {
                    duration: 0.05,
                    opacity: 1,
                    onComplete: () => {
                        resolve(true);
                    }
                });
        });

    });

    // settingsData.animationsList.push(searchListPromise);
    searchAnimations.push(searchListPromise);

    if (isMobile && !settingsData.isLandscape && settingsData.searchListOpened) {
        toggleResultsList();
    }

    return Promise.all(searchAnimations);
}

function getPositionValueMobileContainer() {
    const container = document.querySelector('.search__container-main');
    const menuMobile = document.querySelector('.additional-menu__container');
    const wrapperTop = document.querySelector('.search__top-wrapper');

    if (!container) {
        return;
    }

    const containerHeight = container.clientHeight;
    let firstThreeElements = 0;

    for (let i = 0; i < wrapperTop.childNodes.length - 1; i++) {
        firstThreeElements += wrapperTop.childNodes[i].clientHeight;
    }

    const position = (!settingsData.isLandscape) ? menuMobile.clientHeight - (containerHeight - firstThreeElements - menuMobile.clientHeight / 2) : 0;

    return position;
}

/**
 * Resize search container
 */
export function searchResizeCanvas() {
    if (isMobile && !settingsData.isLandscape) return;

    const size = {
        x: window.innerWidth,
        y: window.innerHeight
    }

    // if (settingsData.activeViewMode !== ViewMode.Orbit) {
        const recalculatedSize = recalculateCanvasSize();

        size.x = recalculatedSize.x;
        size.y = recalculatedSize.y;
    // }

    //Animate canvas resize
    const vectorSize = new Vector2(size.x, size.y);
    const canvasCurrentSize = threeJsVariables.renderer.getSize(new Vector2());

    const time = (settingsData.isLandscape) ? 0.25 : 0.35;

    return new Promise(resolve => {
        gsap.to(canvasCurrentSize, {
            duration: time,
            x: vectorSize.x,
            y: vectorSize.y,

            onUpdate: () => updateComponentsOnCanvasResize(canvasCurrentSize),
            onComplete: () => {
                updateLabels();
                resolve(true);
                // fitModelInViewport(true);
            },
        });
    });

    // settingsData.animationsList.push(resizePromise);
}

export function updateComponentsOnCanvasResize(canvasCurrentSize) {
    threeJsVariables.perspectiveCamera.aspect = canvasCurrentSize.x / canvasCurrentSize.y;
    threeJsVariables.perspectiveCamera.updateProjectionMatrix();
    threeJsVariables.labelRenderer.setSize(canvasCurrentSize.x, canvasCurrentSize.y);
    threeJsVariables.renderer.setSize(canvasCurrentSize.x, canvasCurrentSize.y);
    settingsData.postProcessing.isActive && postProcessingResize(canvasCurrentSize.x, canvasCurrentSize.y)
    
}

function recalculateCanvasSize() {
    const direction = getCurrentLangDirection();
    const searchContainer = document.querySelector('.search__container-main');
    const sideBarContainer = document.querySelector('.aside__container');
    const menuWidth = (settingsData.isDesktopMode || settingsData.isLandscape) ? 0 : sideBarContainer.getBoundingClientRect().width;


    const isMinimized = searchContainer?.classList.contains('minimize') || false;

    // console.log('isMinimized: ', isMinimized);

    // let searchWidth = (searchContainer && !isMinimized) ? searchContainer.getBoundingClientRect().width : 0;

    const searchWidth = (!searchContainer)
        ? 0
        : (isMinimized) ? 0 : searchContainer.getBoundingClientRect().width;

    const x = (settingsData.isDesktopMode && direction === 'ltr' || isMobile && settingsData.isLandscape)
        ? window.innerWidth - (searchWidth + menuWidth)
        : window.innerWidth + (searchWidth + menuWidth);

    const y = window.innerHeight;

    return {x, y};
}

/**
 * Container position if RTL or LTR direction
 */

export const changeSearchModulePosition = () => {
    const mainContainer = document.querySelector('.search__container-main');

    if (!mainContainer) return;

    const menuContainer = document.querySelector('.aside__container');
    const unitCard = UnitCardClass.findCard()?.html;
    const currentDirection = document.documentElement.getAttribute('dir');
    const menuContainerWidth = +menuContainer.getAttribute('data-initial-width');
    // const flexibleInput = document.querySelector('.search__input-flexible');
    // const flexibleInputDictionaryAttribute = flexibleInput.getAttribute('data-dictionary');

    // flexibleInput.setAttribute('placeholder', `${changeLangToCurrent(flexibleInputDictionaryAttribute)}`);

    switch (currentDirection) {
        case 'rtl': {
            mainContainer.removeAttribute('style');
            mainContainer.setAttribute('style', `right:${menuContainerWidth}px`);
            break;
        }
        case 'ltr': {
            mainContainer.removeAttribute('style');
            mainContainer.setAttribute('style', `left:${menuContainerWidth}px`);
            break;
        }
        default:
            break;
    }

    removeSearchContainer('immediately');
    if (isMobile) {
        !unitCard && openSearchHandler();
    } else {
        openSearchHandler();
    }
}

/*
const toggleTabsMobile = () => {
    const tabsList = document.querySelector('.search__top-wrapper');

    tabsList.addEventListener('click', (e) => {
        e.stopPropagation();
        let target = e.target;
        if (target.hasAttribute('type')) return;

        let currentElement = target.getAttribute('data-type');
        if (!currentElement) {
            target = target.parentNode;
            currentElement = target.getAttribute('data-type');
            if (!currentElement) {

                target = target.parentNode;
                currentElement = target.getAttribute('data-type');

                if (!currentElement) return;
            }
        }

        document.querySelectorAll(`.search__option`).forEach(element => {
            element.classList.contains('active') && element.classList.remove('active');
        });
        target.classList.add('active');

        toggleAnimation(currentElement);

    }, true)
}

const toggleAnimation = (option) => {
    let mutableElement =  document.querySelector(`.search__option-input[data-type=${option}]`).parentNode;
    const tl = gsap.timeline();

    if (!mutableElement.classList.contains('search__wrapper')) {
        mutableElement = mutableElement.parentNode;
    }

    tl.to([document.querySelectorAll(`.search__wrapper`)], {
        opacity: 0,
        duration: .2,
        onComplete: () => {
            document.querySelectorAll(`.search__wrapper`).forEach(elem => elem.style.display = 'none');
            console.log('search__wrapper');
        }
    });

    tl.fromTo(mutableElement, {
        opacity: 0,
        delay: .7,
        duration: .2
    }, {
        display: 'flex',
        opacity: 1,
        duration: .2,
    });
}*/
